import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getReservationStatuses } from 'modules/settings/api';

export const useQueryReservationStatuses = () => {
  return useQuery(QUERY_KEYS.SETTINGS_RESERVATION_STATUSES, getReservationStatuses);
};
